
import AnomaliesTabs from "./AnomaliesMobileContent/AnomaliesTabs"


const AnomaliesMobile = () => {
  return (
     <>
     <AnomaliesTabs />
    </>
  )
}

export default AnomaliesMobile